import React from 'react';

import { Banner } from './AnimationBanner.styles';

const RoSlider = props => {
  const { day, hour } = props.time;

  return <Banner>{`${day} ${props.at} ${hour}`}</Banner>;
};

export default RoSlider;
